if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.viewer || !this.elements.thumbnails) return;
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach(item => {
        item.querySelector('button')?.addEventListener('click', this.setActiveMedia.bind(this, item.dataset.target, false));
      });
      if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }
    onSlideChanged(event) {
      const current = event.detail?.currentElement;
      if (!this.isConnected || !current?.dataset.mediaId || !this.elements.thumbnails) return;
      if (this.closest('.lp-editorial') && !this.mql.matches && !current.classList.contains('is-active')) {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(item => item.classList.toggle('is-active', item === current));
        window.pauseAllMedia?.();
      }
      this.setActiveThumbnail(this.elements.thumbnails.querySelector(`[data-target="${current.dataset.mediaId}"]`));
    }
    setActiveMedia(mediaId, prepend) {
      const active = this.elements.viewer?.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer?.querySelector('[data-media-id]');
      if (!active) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach(item => item.classList.remove('is-active'));
      active.classList.add('is-active');
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${active.dataset.mediaId}"]`);
      if (prepend) {
        if (active.parentElement.firstElementChild !== active) active.parentElement.prepend(active);
        if (thumbnail && thumbnail.parentElement.firstElementChild !== thumbnail) thumbnail.parentElement.prepend(thumbnail);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        this.elements.thumbnails?.resetPages?.();
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (!this.isConnected) return;
        if (!this.mql.matches || this.elements.thumbnails) active.parentElement.scrollTo({ left: active.offsetLeft });
        // Changing an editorial option must not yank the shopper back to the gallery.
        if (this.closest('.lp-editorial')) return;
        const rect = active.getBoundingClientRect();
        if (rect.top > -0.5) return;
        window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
      });
      this.playActiveMedia(active);
      if (!thumbnail) return;
      this.setActiveThumbnail(thumbnail);
      this.announceLiveRegion(active, thumbnail.dataset.mediaPosition);
    }
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach(button => button.removeAttribute('aria-current'));
      thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');
      if (this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) return;
      this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
    }
    announceLiveRegion(active, position) {
      const image = active.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      const announce = () => {
        if (!this.isConnected) return;
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        clearTimeout(this.announcementTimer);
        this.announcementTimer = setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };
      if (image.complete && image.naturalWidth) announce();
      else image.addEventListener('load', announce, { once: true });
    }
    playActiveMedia(active) {
      window.pauseAllMedia?.();
      active.querySelector('.deferred-media')?.loadContent(false);
    }
    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
    }
    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
    disconnectedCallback() { clearTimeout(this.announcementTimer); }
  });
}
